import React, { useState } from 'react';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Home from './Home';
import Quiz from './Quiz';
import Flowchart from './Flowchart';
import Background from './Background';
import { careerQuiz } from './data/careerQuiz';
import { petFlowchart } from './data/petFlowchart';

const darkTheme = createTheme({
  palette: {
    mode: 'dark',
  },
});

function App() {
  const [view, setView] = useState('home');

  const renderView = () => {
    switch (view) {
      case 'careerQuiz':
        return <Quiz quizData={careerQuiz} setView={setView} />;
      case 'petFlowchart':
        return <Flowchart flowchartData={petFlowchart} setView={setView} />;
      default:
        return <Home setView={setView} />;
    }
  };

  return (
    <ThemeProvider theme={darkTheme}>
      <CssBaseline />
      <Background />
      <AppBar position="static">
        <Toolbar>
          <Typography variant="h6" component="div" sx={{ flexGrow: 1 }} onClick={() => setView('home')}>
            What's Best For Me?
          </Typography>
        </Toolbar>
      </AppBar>
      <main style={{ position: 'relative', zIndex: 1 }}>
        {renderView()}
      </main>
    </ThemeProvider>
  );
}

export default App;
